import { gql } from '@apollo/client';

export const GET_CAMPAIGNS_FOR_EXPORT = gql`
  query GET_CAMPAIGNS_FOR_EXPORT(
    $filterOptions: CampaignFilterOptionsV5
    $sort: CampaignSortOptionV5
    $order: OrderOption
    $limit: Int
    $offset: Int
  ) {
    campaigns: campaignsV5(
      filterOptions: $filterOptions
      sortOptions: { sort: $sort, order: $order }
      paginationOptions: { limit: $limit, offset: $offset }
    ) {
      edges {
        node {
          __typename
          id
          name
          adAccount {
            id
            name
            timezone
            organizationId
          }
          crmLink {
            id
            name
          }
          advertiser
          agency
          budget
          campaignTagList {
            id
            type
            url
            isVerified
          }
          hasZeroDeliveryRisk
          hasMisalignedSchedule
          orderOmsLink {
            id
          }
          orderType
          trackingId
          traffickerEmail
          startDate
          endDate
          createdAt
          updatedAt
          industryList {
            id
            name
          }
          order {
            salespersonEmail
            billingCalendar
          }
          campaignLineItems {
            id
            countries
            unitCostDto {
              currency
            }
          }
          status
          timezone
        }
      }
      total
    }
  }
`;
